import type { SerializedStyles, Theme } from "@emotion/react";
import type { HTMLProps, ReactNode } from "react";

import { useIsDS4Enabled } from "@aviary/hooks/useIsDS4Enabled";

import * as styles from "./CardWrapper.styles";

interface Props extends HTMLProps<HTMLDivElement> {
  hasBorderStyle?: boolean;
  hasHoverStyle?: boolean;
  isResponsive?: boolean;
  styleOverrides?:
    | SerializedStyles
    | (SerializedStyles | ((theme: Theme) => SerializedStyles))[]
    | ((theme: Theme) => SerializedStyles);
  children: ReactNode;
}

const CardWrapper = ({
  children,
  hasBorderStyle = true,
  hasHoverStyle = true,
  isResponsive = true,
  styleOverrides,
  ...rest
}: Props) => {
  const isDS4Enabled = useIsDS4Enabled();

  const cardWrapperStyles = [
    styles.cardWrapper.base,
    hasBorderStyle && styles.cardWrapper.hasBorderStyle,
    hasHoverStyle && styles.cardWrapper.hasHoverStyle,
    isResponsive && styles.cardWrapper.isResponsive,
    isDS4Enabled && styles.cardWrapper.ds4,
    isDS4Enabled && hasBorderStyle && styles.cardWrapper.ds4Border,
    isDS4Enabled && hasHoverStyle && styles.cardWrapper.ds4Hover,
    styleOverrides,
  ];

  return (
    <div css={cardWrapperStyles} {...rest}>
      {children}
    </div>
  );
};

export { CardWrapper };
